import types from "../types";

const initialState = null;

function customerReducer(state = initialState, { type, payload }) {
  switch (type) {
    case types.CREATE_CUSTOMER:
      return payload;

    case types.UPDATE_CUSTOMER:
      return { ...state, firstname: payload };

    case types.LOGOUT_CUSTOMER:
      return initialState;

    default:
      return state;
  }
}

export default customerReducer;
